<template lang="">
    <div class="h-100">
        <div class="card" v-if="mesSouscriptions">
            <div class="row bg-dark text-white border border-2 rounded p-2 w-100">
                <p>Rappel: Il vous reste encore des souscriptions sans patients</p>
            </div>
            <div class="card-header mb-2 mt-2 title">
                <h3 class="card-title mb-2 mt-2 title pl-2">
                    {{ $t('message.SouscripteurDashboard') }}
                </h3>
                <p class="pl-2">Veuillez selectionner un CIM et ajouter un patient SVP <strong class="colorGrey">(*optionnel)</strong>. </p>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-4 w-100" v-for="(value, key) in mCommandes" :key="key">
                        <div v-b-toggle="'collapse'+key" class="mt-3 w-100 mx-1"  v-if="value.nombre_restant > 0">
                            <span class="border border-5 rounded py-3 px-1 row CimsList cimHeight"  id="disabled-wrapper" @click="onNext(), form.offre=value, form.package=value.id, description=value.type_contrat.description_fr" >
                                <!-- <i class="fa fa-calendar text-primary" aria-hidden="true"></i> -->
                                <div class="col-6 col-md-6 text-default"> <h5 class="text-dark">{{truncate(value.type_contrat.description_fr, 18) }}</h5>
                                    <h5 class="font-weight-light colorGrey"><i class="fa fa-circle-red" aria-hidden="true"></i>{{value.nombre_restant}}/{{value.nombre_paye}}</h5>
                                </div>
                                <div class="col-6 col-md-6 pt-2">
                                        <span class="border border-primary bg-primary rounded text-white py-1 px-3 float-right"><i class="fa fa-user-plus pr-2" aria-hidden="true"></i>Patient</span>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
        
            <div class="d-flex justify-content-md-end justify-content-center pr-md-5 mt-5">
                <div :class="[mobileView ? 'w-100 px-2' : 'px-2']">
                    <button class="btn btn-outline-dark w-100" @click="$emit('getHome')">Non, Plus tard</button>
                </div>
                <div class="d-none p-2">
                    <button class="btn btn-success" @click="completeInfo=false,mesSouscriptions=false,addPatient=false,selectPatient=true,consentement=false,getStarted=false,hideView=false">Ok, Suivant</button>
                </div>
            </div>
            
            <div class="row d-flex justify-content-center pb-4">
                  
            </div>
        </div>
        </div>
        <div class="col-md-5 mx-md-auto col-12" v-else-if="selectPatient">
            <div class="card">
                <div class="row bg-dark text-white border border-2 rounded p-2 w-100">
                    <p>Listing des patients</p>
                </div>
                <div class="mx-3 my-4">
                    <div class="mb-3">
                        <label for="">Selectionnez votre patient</label>
                            <multiselect v-model="patient" id="patient"  label="nom" track-by="dossier" placeholder="Selectionnez patient" :options="mAffiliates" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="" @select="addOldPatient=true, patientInfo=true">
                                <template slot="clear" slot-scope="props">
                                    <div class="multiselect__clear" v-if="patient" @mousedown.prevent.stop="clearAll(props.search)"></div>
                                </template><span slot="noResult">Ajouter un patient</span>
                            </multiselect>
                    </div>
                    <div class="bgDetails row" v-if="patientInfo">
                        <div>
                            <p class="mb-1 mt-2 fs3 fwB ml-3">
                                Identifiants du patient
                            </p>
                        </div>
                        <div class="row w-100 my-2">
                            <div class="col-md-6 w-100"><span class="mr-2 fwB">Nom</span>{{patient.nom}}</div>
                            <div class="col-md-6 w-100"><span class="mr-2 fwB">Sexe</span>{{patient.sexe}}</div>
                        </div>
                        <div class="row w-100 mb-2">
                            <div class="col-md-6 w-100"> <span class="mr-2 fwB">Date de naissance</span> {{patient.date}}</div>
                            <div class="col-md-6 w-100"> <span class="mr-2 fwB">Status du contrat</span>{{patient.status_contrat}}</div>
                        </div>
                    <!-- {{patient.pay.user_id}}  -->
                    </div>
                    <p class="mb-3 mt-4 fs3 fwB" v-if="!patient">
                        Créer un nouveau patient
                    </p>
                    <div v-if="!patient">
                        <span class="border border-primary bg-primary rounded text-white py-1 px-3 cursor"  @click="completeInfo=false,mesSouscriptions=false,addPatient=true,selectPatient=false,consentement=false,getStarted=false,hideView=false">
                            <i class="fa fa-user-plus pr-2" aria-hidden="true"></i>Patient
                        </span>
                    </div>

                    <div class="d-flex justify-content-between pr-md-5 mt-5">
                        <div class="px-2">
                            <button class="btn btn-outline-dark" @click="completeInfo=false,mesSouscriptions=true,addPatient=false,selectPatient=false,consentement=false,getStarted=false,hideView=false">Précedent</button>
                        </div>
                        <div class="" v-if="addOldPatient">
                            <button class="btn btn-success" @click="completeInfo=false,mesSouscriptions=false,addPatient=false,addOldPatient=true,selectPatient=false,consentement=false,getStarted=false,hideView=false">Suivant</button>
                        </div>
                    </div>
                </div>

            </div>
       </div>
       <!-- Form for new patients -->
        <div class="card" v-else-if="addPatient">
          
            <firstaddpatient :package_id='form.package' :description_fr="description" @getNext="completeInfo=false,mesSouscriptions=false,addPatient=false,consentement=false,getStarted=true,addOldPatient=false" @getPrevious="completeInfo=false,mesSouscriptions=false,addPatient=false,selectPatient=true,consentement=false,getStarted=false,addOldPatient=false"/>   
        </div>

        <!-- Form for Existing patients -->
        <div class="col-md-8 mx-auto w-100" v-else-if="addOldPatient">
            <div class="card border border-2 rounded">
                <div class="mt-4 mb-2"> 
                    <h3 class="ml-3">Offre de formulaire d'inscription de {{patient.nom}}</h3>
                </div>
                <ul class="notification-card-content"></ul>
                <div>
                    <h4 class="ml-3">Informations sur l'offre et les plaintes</h4>
                </div>
                <b-form @submit="onSubmit" class="mt-4">
                    <div class="row">
                        <div class="col-md-6">
                            <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="niveau-group"
                                        :label="$t('message.niveauUrgence')"
                                        label-for="niveau">
                                        <b-form-select
                                            id="niveau"
                                            v-model="form.niveau"
                                            :state="$v.form.niveau.$dirty ? !(errorshasField('niveau') || $v.form.niveau.$error) : null"
                                            :options="niveaux"
                                            required
                                            @focus="clearErrorField('niveau')"
                                    >  </b-form-select>
                                    

                                <b-form-invalid-feedback v-if="errorshasField('niveau')">
                                        {{ getErrorsField('niveau') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.niveau.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                                <div class="form-group">
                                    <span class="obligatoire">*</span>
                                    <label for="plainte" class="typo__label">Plaintes</label>
                                    <multiselect v-model="form.plaintes" id="plainte" tag-placeholder="Ajouter une nouvelle plainte" :taggable="true" @tag="addTag" label="description" track-by="id" placeholder="Rechercher ou ajouter une plainte" :options="liste_plaintes" :searchable="true" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" :multiple="true" @search-change="getMotifs">
                                        <template slot="clear" slot-scope="props">
                                            <div class="multiselect__clear" v-if="form.plaintes" @mousedown.prevent.stop="clearAll(props.search)"></div>
                                        </template><span slot="noResult">Ajouter une nouvelle plainte</span>
                                    </multiselect>
                                    <template v-if="$v.form.plaintes.$error">
                                        <small id="emailHelp" v-if="!$v.form.plaintes.required" class="form-text text-danger">Les plaintes sont requises</small>
                                    </template>
                                    <small id="emailHelp" class="form-text text-danger">{{ errors.has('plaintes') ? "Les plaintes sont requises" : "" }}</small> 
                                     <b-form-invalid-feedback v-if="!$v.form.plaintes.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('plaintes')">
                                            {{ getErrorsField('plaintes') }}
                                    </b-form-invalid-feedback>
                                </div>
                        </div>
                        <div class="col-md-6">
                            <b-form-group
                                    id="package-group"
                                    :label="$t('message.cim')"
                                    label-for="package">
                                    <b-form-select
                                                id="package"
                                                v-model="form.package"
                                                :state="$v.form.package.$dirty ? !(errorshasField('package') || $v.form.package.$error) : null"
                                                :options="formCommandes"
                                                required
                                                @focus="clearErrorField('package')"
                                        >  </b-form-select>
                                <b-form-invalid-feedback v-if="!$v.form.package.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('package')">
                                    {{ getErrorsField('package') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group
                                            id="paye_par_affilie-group"
                                            :label="$t('message.paye_par_affilie')+'?'"
                                            label-for="paye_par_affilie">
                                            <div class="custom-control custom-radio custom-control-inline mt-2">
                                                <input type="radio" class="custom-control-input" v-model="form.paye_par_affilie" id="oui" checked value="Oui">
                                                <label class="custom-control-label" for="oui">Oui</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline mt-2">
                                                <input type="radio" class="custom-control-input" v-model="form.paye_par_affilie" id="non" value="Non">
                                                <label class="custom-control-label" for="non">Non</label>
                                            </div>

                                            <!-- <div class="custom-control custom-radio custom-control-inline mt-2">
                                                <input type="radio" class="custom-control-input" v-model="$v.form.paye_par_affilie.$model" id="oui" value="Oui">
                                                <label class="custom-control-label" for="oui">Oui</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline mt-2">
                                                <input type="radio" class="custom-control-input" v-model="$v.form.paye_par_affilie.$model" id="non" value="Non" checked>
                                                <label class="custom-control-label" for="non">Non</label>
                                            </div> -->

                                        <b-form-invalid-feedback v-if="!$v.form.paye_par_affilie.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>
                                        <template v-if="$v.form.paye_par_affilie.$error">
                                            <small id="emailHelp" v-if="!$v.form.paye_par_affilie.required" class="form-text text-danger">Ce champ est obligatoire</small>
                                        </template>
                                        <b-form-invalid-feedback v-else-if="errorshasField('paye_par_affilie')">
                                            {{ getErrorsField('paye_par_affilie') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                        </div>
                    </div>
                </b-form>
                <div class="row">
                    <div class="col-md-6"></div>
                    <div class="col-md-6"></div>
                </div>

                <!-- Form Contact -->
                <fieldset class="px-0 px-md-2">
                            <legend  class="w-auto title text-center">{{ $t('message.personnecontact') }}</legend>
                            <b-row>

                                <b-col sm="4">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="contact_name-group"
                                            :label="$t('message.lastName')"
                                            label-for="contact_name"
                                            description=""
                                    >
                                        <b-form-input
                                                id="contact_name"
                                                v-model="$v.form.contact_name.$model"
                                                :state="$v.form.contact_name.$dirty ? !(errorshasField('contact_name') || $v.form.contact_name.$error) : null"
                                                type="text"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('contact_name')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.contact_name.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('contact_name')">
                                            {{ getErrorsField('contact_name') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>

                                </b-col>
                                <b-col sm="4">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="contact_firstName-group"
                                            :label="$t('message.firstName')"
                                            label-for="contact_firstName"
                                            description=""
                                    >
                                        <b-form-input
                                                id="contact_firstName"
                                                v-model="$v.form.contact_firstName.$model"
                                                :state="$v.form.contact_firstName.$dirty ? !(errorshasField('contact_firstName') || $v.form.contact_firstName.$error) : null"
                                                type="text"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('contact_firstName')"
                                        ></b-form-input>

                                        <b-form-invalid-feedback v-if="!$v.form.contact_firstName.required">
                                            {{ $t('message.requiredField') }}
                                        </b-form-invalid-feedback>

                                        <b-form-invalid-feedback v-else-if="errorshasField('contact_firstName')">
                                            {{ getErrorsField('contact_firstName') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>

                                </b-col>
                                <b-col sm="4">
                                    <span  class="obligatoire">*</span>

                                    <b-form-group
                                            id="contact_phone-group"
                                            :label="$t('message.phoneNumber')"
                                            label-for="contact_phone">

                                            <vue-tel-input
                                                id="contact_phone"
                                                v-model="$v.form.contact_phone.$model" 
                                                :state="$v.form.contact_phone.$dirty ? !(errorshasField('contact_phone') || $v.form.contact_phone.$error) : null"
                                                required
                                                placeholder=""
                                                @focus="clearErrorField('contact_phone')"
                                            ></vue-tel-input>

                                            <template v-if="$v.form.contact_phone.$error">
                                            <small id="telephone" v-if="!$v.form.contact_phone.required" class="form-text text-danger">Le telephone est obligatoire</small>
                                            </template>
                                            <template v-if="!$v.form.contact_phone.minLength">
                                                <small id="telephone" class="form-text text-danger">Minimum 9 chiffres</small>
                                            </template>
                                            <b-form-invalid-feedback v-if="!$v.form.contact_phone.required">
                                                {{ $t('message.requiredField') }}
                                            </b-form-invalid-feedback>
        <!--                                <b-form-invalid-feedback v-if="!$v.form.telephone.integer">-->
        <!--                                      {{ $t('message.integer', { n: 9 }) }}-->
        <!--                                 </b-form-invalid-feedback>-->
                                            <b-form-invalid-feedback v-if="!$v.form.contact_phone.minLength">
                                                {{ $t('message.minCharacters', { n: 9 }) }}
                                            </b-form-invalid-feedback>
                                            <b-form-invalid-feedback v-if="!$v.form.contact_phone.numericValidator">
                                                {{ $t('message.integer', { n: 9 }) }}
                                            </b-form-invalid-feedback>
                                            <b-form-invalid-feedback v-else-if="errorshasField('contact_phone')">
                                                {{ getErrorsField('contact_phone') }}
                                            </b-form-invalid-feedback>
                                        
                                    </b-form-group>

                                </b-col>

                            </b-row>
                        </fieldset>
                
                <b-container class="align-center addpatient mb-4">
                    <div class="d-flex justify-content-md-between justify-content-between mt-4 pr-md-5">
                        <div class="px-2">
                            <button class="btn btn-outline-dark" @click="completeInfo=false,mesSouscriptions=false,addPatient=false,selectPatient=true,consentement=false,getStarted=false">Précedent</button>
                        </div>
                        <div class="px-2 mx-0">
                            <button class="btn btn-success w-100" @click="onSubmit">Terminer</button>
                        </div>
                    </div>
                </b-container>
            </div>
        </div>
        <div class="card" v-else-if="consentement">
            <div class="card-header title bg-transparent">
                <a class="" @click="completeInfo=false,mesSouscriptions=false,addPatient=true,consentement=false,getStarted=false"><i class="fa fa-arrow-left" aria-hidden="true" v-if="mobileView"></i></a>
            </div>
          
        </div>
        <div class="card" v-else-if="getStarted">
            <div class="row d-flex justify-content-between">
                            <div class="container">
                                <h3 class="card-title mb-2 mt-2 title">
                                    Veuillez patienter SVP!!
                                </h3>
                                <h3> L'ajout de votre patient est en cours..</h3>
                                
                            </div>
            </div>
            <div class="row d-flex justify-content-between mt-3">
                                <!-- <div :class="['arrow-circle-dark mr-1']"></div>
                                <div :class="['arrow-circle-dark mx-2']"></div>
                                <div :class="['arrow-circle-success mx-2']"></div> -->
            
                </div>
            <div class="row justify-content-between my-4 pr-2" role="status">
                <div class="loading"></div>
            </div>
        </div>
            
</div>
</template>

<script>
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import firstaddpatient from "../Subscribers/firstaddpatient";
import { mapGetters } from 'vuex';
import _ from 'lodash';
import Multiselect from 'vue-multiselect'
//import SlimSelect from 'slim-select';
import moment from "moment";
import { required, email, integer, minLength } from 'vuelidate/lib/validators';

import axios from 'axios';
import Swal from 'sweetalert2';
import Vue from 'vue';
import AppConfig from '../../constants/AppConfig';
import vueSignature from "vue-signature";
import SlimSelect from 'slim-select';
import controlDoctors from '../../store/modules/control-doctors';
const numericValidator = string => (/^[0-9]+$/gi).test(string);

Vue.use(VueTelInput, {
        dropdownOptions: {
            showSearchBox: true,
            showDialCodeInSelection: true
        },
        inputOptions: {
            required: true,
            autofocus: true,
            showDialCode: true
        },
        invalidMsg:'Saisissez un numéro de téléphone correct',
        preferredCountries: ['cm', 'be', 'fr']
    });

export default {
    name: "WelcomeMedsurlink",
    components:{
            vueSignature,
            firstaddpatient,
            Multiselect 
        },
    data() {
        return { 
            idCim:'0',
            description_fr:'CIM',
            paye_par_affilie: 'Non',
            liste_plaintes: [],
            patientInfo:false,
            mobileView:true,
            hideView:true,
            mesSouscriptions:true,
            addPatient:false,
            selectPatient:false,
            addOldPatient:false,
            patient: '',
            consentement:false,
            getStarted:false,
            niveaux: [{ text: 1, value: 1 }, { text: 2, value: 2 }, { text: 3, value: 3 }, { text: 4, value: 4 }, { text: 5, value: 5 }],
            options: ['Select option', 'options', 'selected', 'multiple', 'label', 'searchable', 'clearOnSelect', 'hideSelected', 'maxHeight', 'allowEmpty', 'showLabels', 'onChange', 'touched'],
            form: {
                    isMed: true,
                    // quartier:'',
                    // code_postal:'',
                    // nom: '',
                    // prenom: '',
                    // adresse: '',
                    // lien: '',
                    offre: [],
                    paye_par_affilie: 'Non',
                    // souscripteur: null,
                    // telephone: '',
                    contact_phone:'',
                    contact_name: '',
                    contact_firstName:'',
                    email: JSON.parse(localStorage.getItem('user')).email,
                    package: '0',
                    // sexe: '',
                    // date_de_naissance: '',
                    // nationalite: '',
                    // ville: '',
                    // pays: 'Cameroon',
                    // institution:[],
                    niveau: null,
                    plaintes: [],
                    is_loading: false,

                },
                paye_par_affilies: [
                    { value: 'oui', text: "Oui" },
                    { value: 'non', text: "Non" }
                ],
                show: true,
          
            option:{
				    penColor:"rgb(0, 0, 0)",
                    backgroundColor:"rgb(255,255,255)"
                },
                disabled: JSON.parse(localStorage.getItem('user'))['signature'] == null ? true : false,
                dataUrl: JSON.parse(localStorage.getItem('user'))['signature'],
                consentement: 1,
                // form: this.subscriber != null ? this.subscriber : {user: JSON.parse(localStorage.getItem('user')), sexe: JSON.parse(localStorage.getItem('user'))['souscripteur']['sexe']},
                sexes: [
                    { value: 'F', text: this.$i18n.t('message.female') },
                    { value: 'M', text: this.$i18n.t('message.male') }
                ],
                subscriber_id: JSON.parse(localStorage.getItem('user'))['slug'],
                signature: JSON.parse(localStorage.getItem('user'))['signature'],
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled: {enabled: true},

                sort: {
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },
                affiliateColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'type_contrat.description_fr',
                    },
                    {
                        field: 'nombre_restant',
                        label: this.$i18n.t('message.fileNumber')
                    },
                    {
                        field: 'type_contrat.montant',
                        label: this.$i18n.t('message.old')
                    },
                    {
                        field: 'created_at',
                        label: this.$i18n.t('message.email')
                    },
                ],
        }
    },

    watch:{
            hasPatientEmail:function(oldValue,newValue){
                if(newValue == false){
                    this.form.email = "";
                }
            },

            searchTerm:function (newValue, oldValue) {
                if (!this.hasPatientRole){
                    if (newValue.trim().length ==0){
                        this.mSubscribersFilter = [];
                    }else{
                        this.mSubscribersFilter = this.mSubscribers;
                    }
                }else{
                    this.mSubscribersFilter =this.mSubscribers;
                }
            }


        },

    computed: {
            ...mapGetters(["subscriber", 'hasAdminRole', "countries", "patients",
                'hasGestionnaireRole','hasSouscripteurRole','hasMedecinControleRole','hasPraticienRole',
                "affiliations","commandes"]),
        mSubscriber: function () {
            /* if(this.subscriber.affiliation[0].nombre_restant > 1){
               this.$router.push({ name: 'add-patient-souscripteur'});
             }*/
            this.subscriber_id = this.subscriber.id;
            return this.subscriber;
        },
        mCommandes: function () {
           
            let restant = [];
            if (!_.isUndefined(this.commandes) && !_.isNull(this.commandes)) {
                restant = this.commandes;
            }
            return restant;
        },
        formCommandes: function (){
                let offres = [];
                if( !_.isUndefined(this.commandes) && !_.isNull(this.commandes)){
                _.forOwn(this.commandes, function(value) {
                    if(value.nombre_restant >=0){
                        offres.push({ text: value.type_contrat.description_fr, value: value.id, id: value.type_contrat.offre_id });
                    }
                });
                }

                return offres;
            },
        mCountries: function () {
            let cArray = [];

            _.forOwn(this.countries, function (value, key) {
                cArray.push({ text: value.name, value: value.name });
            });

            return cArray;
        },
        
        mAffiliate: function () {
            let pArray = [];
            _.forEach(this.patients, function (patient) {
                let p = {};

                if (typeof patient.user == 'object') {
                    if (!_.isUndefined(patient.dossier)) {
                        if (!_.isNull(patient.dossier)) {
                            p.nom = (patient.user.prenom ? ' ' + patient.user.prenom : '') + "  " + (patient.user.nom).toUpperCase();
                            p.dossier = patient.dossier.numero_dossier;
                            p.email = patient.user.email;
                            p.telephone = patient.user.telephone;
                            p.age = patient.age;
                            p.sexe = patient.sexe;
                            p.nationalite = patient.user.nationalite;
                            p.ville = patient.user.ville;
                            p.pays = patient.user.pays;
                            p.date = moment(patient.user.date_de_naissance).format('DD-MM-YYYY');
                            p.id = patient.user.id;
                            p.slug = patient.user.slug;
                            p.adresse = patient.user.adresse;
                            p.fileSlug = patient.dossier.slug;
                            pArray.push(p);
                        }
                    }
                }
            });
            return pArray;
        },
        mAffiliates:function(){
                let pArray = [];
                // console.log('subscriber ', this.subscriber.patients)
                // console.log('subscriber ', this.affiliations)
                _.forEach(this.affiliations, function(affiliation) {
                    let p = {};
                    p.pay = affiliation.patient;
                    p.produit = affiliation.package.description_fr != null ? affiliation.package.description_fr : "CIM";
                    p.nom = (affiliation.patient.user.prenom ? affiliation.patient.user.prenom : '') + "  " + (affiliation.patient.user.nom ? (affiliation.patient.user.nom).toUpperCase() : '') ;
                    p.dossier = affiliation.patient.dossier ? affiliation.patient.dossier.numero_dossier : '';
                    p.dossierSlug = affiliation.patient.dossier ? affiliation.patient.dossier.slug : '';
                    p.email = affiliation.patient.user.email;
                    p.telephone = affiliation.patient.telephone;
                    p.age = affiliation.patient.age;
                    p.nationalite = affiliation.patient.nationalite;
                    p.ville = affiliation.patient.ville;
                    p.pays = affiliation.patient.pays;
                    p.sexe = affiliation.patient.sexe;
                    p.date = moment(affiliation.patient.date_de_naissance).format('DD-MM-YYYY');
                    p.id = affiliation.patient.id;
                    p.qualite = affiliation.patient.financeurs[0] == undefined ? 'Autres': (affiliation.patient.financeurs[0].lien != null ? affiliation.patient.financeurs[0].lien.fr_description : 'Autres');
                    p.date_debut = affiliation.date_debut;
                    p.date_fin = affiliation.date_fin;
                    p.slug = affiliation.slug;
                    p.adresse = affiliation.patient.adresse;
                    p.status_contrat = affiliation.status_contrat;
                    
                    pArray.push(p);
                });
                return pArray;
            },

        mSubscriberUserInformation: function () {
            if (typeof this.mSubscriber.user == 'object') {
                return this.mSubscriber.user;
            }
            return [];
        },

        fullName: function () {
            let prenom = this.mSubscriberUserInformation.prenom != null ? this.mSubscriberUserInformation.prenom : "";
            return this.getValue(prenom) + "  " + (this.getValue(this.mSubscriberUserInformation.nom)).toUpperCase();

        },

        rows: function () {
            if (typeof this.mSubscriber.patients == "object")
                return this.mSubscriber.patients.length;
            return 0;
        },

        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole;
        },

        // Compute Ajouter patient

        ...mapGetters(["countries", "subscribers", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole','hasMedecinControleRole','hasAssistante',
                'hasSouscripteurRole',
                "userInstitutions",
                "questions",'hasAssistante'
            ]),

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            mUserInstitutions: function() {
                let iArray = [];

                _.forEach(_.orderBy(this.userInstitutions,['created_at'],['desc']), function(institution) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                    i.date = moment(institution.created_at).format('DD-MM-YYYY');
                    i.id = institution.id;
                    i.slug = institution.slug;

                    iArray.push(i);
                });

                return iArray;
            },


            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasSouscripteurRole || this.hasAssistante;
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },


            mQuestions: function() {
                let qArray = [];

                _.forOwn(this.questions, function(value, key) {
                    qArray.push({ text: value.intitule, value: value.id });
                });

                return qArray;
            },

            mSubscribers: function() {
                let sArray = [];

                _.forOwn(this.subscribers, function(value, key) {
                    if (!_.isNull(value.user)){
                        let prenom  = value.user.prenom ? value.user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        let fullName = (value.user.nom).toUpperCase()+ " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        sArray.push({ text: fullName, value: value.user.id });
                    }
                });

                return sArray;
            },

    },

    methods: {
        addTag (newTag) {
                const tag = {
                    id: "item_"+newTag,
                    description: newTag
                }
                this.liste_plaintes.push(tag)
                this.form.plaintes.push(tag)
            },
            getMotifs(motif){
                this.loading = true;
                fetch(AppConfig.apiUrl+`/search/motif/${motif}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                .then(res => {
                    this.loading = false;
                    this.liste_plaintes = res.motifs.map(item => ({id: item.id, description: item.description})).filter(item => item.description != "" && item.description != "[object Object]");
                }).catch(error => {
                    console.log('error ', error);
                })
            },
        truncate(str, n){
            return (str.length > n) ? str.slice(0, n-1) + '...' : str;
        },
        passParams: function(event) {
            targetId = event.currentTarget.id;
            targetId = event.currentTarget.id;
           // returns 'foo'
        },
        goToHome(){
            this.$router.push('/souscripteur-dashboard'); 
                },
        goToEnd(){
            this.completeInfo=false,this.mesSouscriptions=false,this.addPatient=false,this.consentement=false,this.getStarted=true,this.addOldPatient=false
        },
        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
        getSubscriber() {
                let args = {
                    subscriber: this.subscriber_id
                };

                this.$store.dispatch("getSubscriber", { args });
            },
        checkIfProfileComplete(){
                let user = JSON.parse(localStorage.getItem('user'));
                if(user.souscripteur.sexe == ''){
                    this.$bvModal.show('modal-scoped');
                    }
                if(this.dataUrl == null){
                    this.$bvModal.show('consentement');
                }
            },
        getAffiliations() {
                let args = {
                    offset: this.offset,
                    limit: this.limit,
                    id:(JSON.parse(localStorage.getItem('user')))['id']
                };

                this.$store.dispatch('getAffiliationsSouscripteur', { args : args });
            }, 
            goToPaiement :function(){

               this.$router.push({ name: 'paiement', params: { identifiant: (JSON.parse(localStorage.getItem('user')))['slug'] } });

            },

            gotToMesAffilies: function() {

                this.$router.push({ name: 'mesAffilies'});
                
            },

            addPatientToAffiliation: function() {
                let offres = [];
                if( !_.isUndefined(this.commandes) && !_.isNull(this.commandes)){
                _.forOwn(this.commandes, function(value) {
                    if(value.nombre_restant >=0){
                        offres.push({ text: value.type_contrat.description_fr, value: value.id, id: value.type_contrat.offre_id});
                        
                    }
                });
                this.$router.push({ name: 'add-patient-souscripteur', params:{id: offres.id}});//params:{id: this.commandes.type_contrat.offre_id}
                
                }
                
                
            },

            GenerationFacture: affiliation => {
                axios.get(`${AppConfig.apiUrl}/impression/facture-offre/${affiliation.id}`).then(res => {
                    window.open(res.data.link, '_blank');
                }).catch(error => {
                    console.log('error ', error);
                })
            },

            getPatients() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };
                
                this.$store.dispatch('getPatients', { args : args });
            },

            onaffiliateRowClick(params){
                // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                this.$router.push((this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug } })).href +  '#generale');

            },
            onNext: function(evt) {
               this.mesSouscriptions=false,this.addPatient=false,this.consentement=false,this.getStarted=false,this.selectPatient=true
            
            },
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();
                let args = {
                        // nom: this.form.nom,
                        // prenom: this.form.prenom,
                        souscripteur_id: (JSON.parse(localStorage.getItem('user')))['id'],
                        patient_id: this.patient.pay.user_id,
                        cim_id:  this.form.package,
                        urgence: this.form.niveau,
                        selected: 3,
                        plaintes: this.form.plaintes.map(item => item.id),
                        contact_firstName: this.form.contact_firstName,
                        contact_name: this.form.contact_name,
                        contact_phone: this.form.contact_phone,
                        status_contrat: 'Actif',
                        nom_pere:'',
                        nom_mere: '',
                        package_id: this.form.offre.cim_id,
                        type_contrat: this.form.offre.type_contrat,
                        paye_par_affilie: this.form.paye_par_affilie,
                        // lien_parente: this.form.lien,
                        // quartier:this.form.quartier,
                        // code_postal:this.form.code_postal
                };
                console.log(args);
                if(!this.$v.$invalid ) {
                    let successMessage = this.$i18n.t('message.patientCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };
                    this.is_loading = true;
                    this.$store.dispatch('createOldPatientSouscripteur', { args, errorMessages, successMessage })
                        .then(() => {
                            this.goToEnd();
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                            this.is_loading = false;
                        }).catch(() => {
                            this.is_loading = false;
                        });
                    
                }else{
                    console.log(this.$v)
                }
            },
            getSubscriber() {
                let args = {
                    subscriber: this.subscriber_id
                };

                this.$store.dispatch("getSubscriber", { args });
            },

            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            },
            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            getCommandes: function() {
                let args = {
                    souscripteur: (JSON.parse(localStorage.getItem('user')))['id']
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                this.$store.dispatch('getCommandes', { args, errorMessages });
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },
            /**
             * signature
             */
            
          
            save(){
                var _this = this;
                const formData = new FormData();
                //if((this.dataUrl!= null) && (!this.dataUrl.includes(".png"))){
                    const signature = _this.$refs.signature.save();
                    formData.append('signature', signature)
                //}
                formData.append('id', JSON.parse(localStorage.getItem('user'))['id'])
                formData.append('consentement', this.consentement ? 1 : 0)
                formData.append('souscripteur', 1)

                axios.post(`${AppConfig.apiUrl}/signature/user`, formData, {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'Authorization': "Bearer " + localStorage.getItem('ms-token')
                    }
                }).then(res => {
                    this.$bvModal.hide('consentement');
                    Vue.swal("Votre signature a été ajouter avec succès", '', 'success');
                    let user = JSON.parse(localStorage.getItem('user'));
                    user = {...user, signature: res.data.signature};
                    localStorage.setItem("user", JSON.stringify(user));
                    this.disabled = false;
                    this.dataUrl = res.data.signature;
                }).catch(error => {
                    console.log('error ', error);
                })

            },
            clear(){
                var _this = this;
                this.disabled = true;
                _this.$refs.signature.clear();
            },
            undo(){
                var _this = this;
                _this.$refs.signature.undo();
            }
        },

        validations: {
            form: {
                niveau: {
                    required,
                },
                paye_par_affilie : {
                    required
                },
                contact_name: {
                    required
                },
                contact_firstName:{
                    required
                },
                contact_phone: {
                    required,
                    minLength: minLength(9),
                },
                
                plaintes: {
                        required
                    },
                package:{
                    required,
                },
            }
        },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        this.checkIfProfileComplete();
        this.getSubscriber();
        this.getPatients();
        this.getCountries();
        this.getAffiliations();
        /*  new SlimSelect({
             select: '#single',
             placeholder: 'Select Country'
         }); */
        //this.$refs.tooltip.$emit('enable')
        // Retrieve list of subscribers
        this.getCommandes();
    }
}
</script>
<style lang="" src="vue-multiselect/dist/vue-multiselect.min.css">
    
</style>